import { useMutation } from 'react-query';

import { QueryResponse, createMultipleReportNewTags as mutationFn } from 'api/endPoints/CreateMultipleReportNewTags';

export const useMutationAddNewTagToReports = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params: QueryParams) => mutationFn(params),
    });
};

type QueryParams = string[];
